
import apiURL from './apiURL';
// const apiURL = "http://localhost:3000"
// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];

// types of action
const Types = {
  COSTCENTER_GET_LIST: "COSTCENTER_GET_LIST",
  COSTCENTER_UPDATE: "COSTCENTER_UPDATE",
  COSTCENTER_SAVE: "COSTCENTER_SAVE",
  COSTCENTER_ADD: "COSTCENTER_ADD",
  COSTCENTER_REMOVE: "COSTCENTER_REMOVE",
};

const removeCostCenter = (id) => ({
  type: Types.COSTCENTER_REMOVE,
  id
});

const addCostCenter = (parent) => ({
  type: Types.COSTCENTER_ADD,
  parent
});

const updateCostCenter = (id,field,value) => ({
  type: Types.COSTCENTER_UPDATE,
  update: {id,field,value}
});

const costCenterUpdateList = response => ({
  type: Types.COSTCENTER_GET_LIST,
  payload: response
});

const costCentersGetList = () => {
  return (dispatch, getState) => {

    fetch(apiURL + `/settings/costCenters` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(costCenterUpdateList(data))
    })
  }
}

const costCentersSaved = response => ({
  type: Types.COSTCENTER_SAVE,
  payload: response
});

const saveCostCenters = () => {
  return (dispatch, getState) => {

    const state = getState()

    const costCenters = state.costCenter.costCenterList

    console.log('costCenters',costCenters)

    fetch(apiURL + `/settings/costCenters` , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({costCenters}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(costCentersSaved(data))
    })
  }
}

const Actions = {
  costCentersGetList,
  updateCostCenter,
  addCostCenter,
  removeCostCenter,
  saveCostCenters,
}

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions